import React, { Component } from 'react';
import { RadioButtonGroup } from 'material-ui/RadioButton';

class FormRadioButtonGroup extends Component {
    handleChange = (event, value) => {
        const { name, onChange } = this.props;

        onChange(name, value);
    };

    render() {
        const { onChange, required, ...props } = this.props;

        return <RadioButtonGroup onChange={this.handleChange} {...props} />;
    }
}

export default FormRadioButtonGroup;



// WEBPACK FOOTER //
// ./src/UI/FormRadioButtonGroup.js